import IService from '../IService';

export default IService.extend({
  abort() {
    if (app.xhrExpected(this.req)) {
      this.req.abort();
      this.req = null;
    }
  },

  /**
   * @param options
   * @return {Promise}
   */
  get(options) {
    if (options.type === 'ALL') {
      options.type = null;
    }

    options = Object.assign(
      {
        /** search query */
        q: '',
        type: null,
        programmerId: null,
        myWork: false,
        page: 0,
        /** page size */
        size: app.DASHBOARD_RESULTS_PER_PAGE,
        _: Date.now(),
      },
      options
    );

    return new Promise((resolve, reject) => {
      this.req = $.ajax({
        url: app.apiUrl('/api/v1/stories/videos', options),
        type: 'GET',
        timeout: app.TIME.minute(),

        dataType: 'json',

        error(jqXHR, textStatus, errorThrown) {
          if ('abort' !== textStatus) {
            reject({ error: errorThrown });
          }
        },

        success(res) {
          if (_.isEmpty(res.storyPreviews)) {
            resolve({ videos: [], noMore: true });
          } else {
            resolve({
              videos: res.storyPreviews,
              noMore: !res.storyPreviews || !res.storyPreviews.length,
            });
          }
        },
      }).always(() => {
        this.req = null;
      });
    });
  },
});
